export const SET_ROLES = 'roles/set-roles';
export const SET_SELECTED = 'roles/set-selected-role';
export const SET_USER_REFS = 'roles/set-user-refs';
export const REMOVE_ROLE = 'roles/remove-role';
